<template>
    <ValidationObserver ref="observer" v-slot="{ passes }">
        <b-form @submit.prevent="passes(saveGroup)" id="group-form">
            <b-row>
                <b-col cols="12" class="mb-2">
                    <b-row class="text-left">
                        <b-col cols="12" md="4" lg="4">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Nombre" invalid-feedback="Ingresa el nombre">
                                    <b-form-input v-model="group.name" autocomplete="false" placeholder="Nombre"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="8" lg="8">
                            <label style="margin-bottom: 7px">Usuarios</label>
                            <v-select label="name" :options="users" debounce="300" placeholder="Usuarios" multiple :reduce="user => user.id"
                                      @search="getUsers" @search:focus="getUsers" :filterable="false" v-model="group.users">
                                <template slot="no-options">Sin resultados.</template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">{{ option.name }}</div>
                                    <div class="d-center" v-if="option.email">{{ option.email }}</div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">{{ option.name }}</div>
                                </template>
                            </v-select>
                        </b-col>
<!--                        <b-col cols="12" md="4" :lg="true">-->
<!--                            <label style="margin-bottom: 7px">Grupo base</label>-->
<!--                            <v-select label="name" :options="groups" debounce="300" placeholder="Grupo base"-->
<!--                                      @search="getGroups" @search:focus="getGroups" :filterable="false" v-model="group.parent">-->
<!--                                <template slot="no-options">Sin resultados.</template>-->
<!--                                <template slot="option" slot-scope="option">-->
<!--                                    <div class="d-center"><span v-for="i in option.level" :key="i" class="px-2"></span>{{ option.name }}</div>-->
<!--                                </template>-->
<!--                                <template slot="selected-option" slot-scope="option">-->
<!--                                    <div class="selected d-center">{{ option.name }}</div>-->
<!--                                </template>-->
<!--                            </v-select>-->
<!--                        </b-col>-->
                    </b-row>
                </b-col>
            </b-row>
<!--            <b-row>-->
<!--                <b-col class="text-left">-->
<!--                    <label style="margin-bottom: 7px">Usuarios</label>-->
<!--                    <v-select label="name" :options="users" debounce="300" placeholder="Usuarios" multiple :reduce="user => user.id"-->
<!--                              @search="getUsers" @search:focus="getUsers" :filterable="false" v-model="group.users">-->
<!--                        <template slot="no-options">Sin resultados.</template>-->
<!--                        <template slot="option" slot-scope="option">-->
<!--                            <div class="d-center">{{ option.name }}</div>-->
<!--                            <div class="d-center" v-if="option.email">{{ option.email }}</div>-->
<!--                        </template>-->
<!--                        <template slot="selected-option" slot-scope="option">-->
<!--                            <div class="selected d-center">{{ option.name }}</div>-->
<!--                        </template>-->
<!--                    </v-select>-->
<!--                </b-col>-->
<!--            </b-row>-->
            <b-row class="mt-1">
                <b-col class="text-right">
                    <b-button variant="primary" type="submit" form="group-form"><font-awesome-icon icon="save"></font-awesome-icon> Guardar</b-button>
                </b-col>
            </b-row>
        </b-form>
    </ValidationObserver>
<!--    <b-card class="m-4">-->
<!--        <template v-slot:footer>-->
<!--            <div class="text-right">-->
<!--                <b-button variant="primary" type="submit" form="group-form"><font-awesome-icon icon="save"></font-awesome-icon> Guardar</b-button>-->
<!--            </div>-->
<!--        </template>-->
<!--    </b-card>-->
</template>

<script>
import * as constants from '@constants';
import { userListUrl, groupListUrl, groupUrl } from '@routes';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

import 'vue2-dropzone/dist/vue2Dropzone.min.css';

extend('required', {
    ...required,
    message: 'Campo requerido'
});

export default {
    props: {
        settings: Object,
        customer: Object
    },
    data() {
        return {
            group: {
                id: 0,
                name: '',
                // parent: null,
                users: []
            },
            users: [],
            groups: []
        }
    },
    created() {
        if (this.$route.name === 'GroupEdit') {
            this.loadData();
        }
    },
    methods: {
        loadData() {
            this.axios.get(groupUrl(), {
                params: {
                    application: constants.PORTAL_USER,
                    customerId: this.customer.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.users = response.data.users;
                } else {
                    this.users = [];
                }
            }).catch(() => {

            });
        },
        getUsers(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            this.axios.get(userListUrl(), {
                params: {
                    searchWord: search,
                    application: constants.PORTAL_USER,
                    customerId: this.customer.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.users = response.data.users;
                } else {
                    this.users = [];
                }
            }).catch(() => {
                this.users = [];
            }).finally(() =>  {
                if (loading) {
                    loading(false);
                }
            });
        },
        getGroups(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            this.axios.get(groupListUrl(), {
                params: {
                    searchWord: search,
                    customerId: this.customer.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let array = response.data.groups;
                    let groups = [];

                    for (let group of array) {
                        groups.push({
                            id: group.id,
                            name: group.name,
                            level: group.level
                        });

                        for (let child of group.children) {
                            groups.push({
                                id: child.id,
                                name: child.name,
                                level: child.level
                            });

                            for (let child of child.children) {
                                groups.push({
                                    id: child.id,
                                    name: child.name,
                                    level: child.level
                                });
                            }
                        }
                    }

                    this.groups = groups;
                } else {
                    this.groups = [];
                }
            }).catch(() => {
                this.groups = [];
            }).finally(() =>  {
                if (loading) {
                    loading(false);
                }
            });
        },
        saveGroup() {
            this.$swal({
                title: '¿Guardar el grupo?',
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    let data = {
                        customerId: this.customer.id,
                        group: {
                            id: this.group.id,
                            name: this.group.name,
                            // parentId: this.group.parent ? this.group.parent.id : 0,
                            userIds: this.group.users
                        }
                    };

                    const method = this.group.id === 0 ? 'post' : 'put';

                    this.axios[method](groupUrl(), data).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            this.$root.$bvToast.toast(response.data.message, {
                                title: 'Grupos',
                                variant: 'success'
                            });

                            this.group =  {
                                id: 0,
                                name: '',
                                // parent: null,
                                users: []
                            }

                            this.$refs.observer.reset();

                            this.$emit('update-groups-data');
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: 'Grupos',
                                variant: 'danger'
                            });
                        }
                    }).catch(error => {
                        console.error(error);

                        this.$bvToast.toast('Ocurrió un error al guardar el grupo.', {
                            title: 'Grupos',
                            variant: 'danger'
                        });
                    });
                }
            });
        }
        // ,
        // getFilesUploadUrl(params) {
        //     console.log(params);
        //
        //     return false;
        // },
        // goBack() {
        //     this.$router.go(-1);
        // },
        // customerSelectClass(errors) {
        //     if (errors[0]) {
        //         return 'customer-select-invalid';
        //     } else {
        //         return '';
        //     }
        // }
    }
}
</script>

<style>

</style>
